import React from "react";
import EditIcon from "../../../Common/Svgs/EditIcon";
import TrashIcon from "../../../Common/Svgs/TrashIcon";
import usePermission from "../../../Core/hooks/usePermission";
import { PERMISSIONS } from "../../Login/constants";

const useThreeDotsOptions = () => {
  const threeDotsOptions = [
    {
      id: 1,
      value: "Edit Details",
      icon: <EditIcon className="text-dark-gray group-hover:text-black" />,
      hasPermission: usePermission([PERMISSIONS.RATE_EDIT]),
    },
    {
      id: 2,
      value: "Delete Commodity",
      icon: <TrashIcon className="text-alert-red" />,
      hasPermission: usePermission([PERMISSIONS.RATE_DELETE]),
    },
  ];

  return threeDotsOptions;
};

export default useThreeDotsOptions;
